// extracted by mini-css-extract-plugin
module.exports = {"label":"Select_label__2DsuP","select":"Select_select__1bvZO","selected":"Select_selected__30zts","option":"Select_option___AmrC","optionDisabled":"Select_optionDisabled__1uobA"};